import { FC } from "react";

import { Bin } from "shared/assets/icons";
import { colors } from "shared/styles/constants";
import { ITheme } from "shared/types";
import { StyledDeleteButton } from "./styles";

export interface DeleteIconProps {
  "data-testid"?: string;
  handleDelete: () => void;
}

export const DeleteIcon: FC<DeleteIconProps> = ({ handleDelete, ...rest }) => {
  return (
    <StyledDeleteButton
      label="delete item"
      icon={Bin}
      onClick={handleDelete}
      theme={ITheme.secondary}
      iconStyle={{ color: colors.red }}
      iconSize="xl"
      {...rest}
    />
  );
};
